/**
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const reportsQueryKeys = {
  all: ['reports'] as const,
  lists: () => [...reportsQueryKeys.all, 'list'] as const,
  list: (filters: object) =>
    [...reportsQueryKeys.lists(), { filters }] as const,
  details: () => [...reportsQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...reportsQueryKeys.details(), id] as const,
};
